interface NeutralLoadingStateProps {
  rows?: number;
  ariaLabel?: string;
  className?: string;
}

export function NeutralLoadingState({
  rows = 4,
  ariaLabel = 'Загрузка',
  className = '',
}: NeutralLoadingStateProps) {
  return (
    <div role="status" aria-live="polite" aria-busy="true" className={className}>
      <ul className="space-y-2.5" aria-label={ariaLabel}>
        {Array.from({ length: rows }).map((_, index) => (
          <li
            key={index}
            className="rounded-[16px] border border-[rgba(26,26,26,0.06)] bg-[rgba(255,255,255,0.64)] p-[13px]"
          >
            <div className="animate-pulse space-y-2">
              <div className="h-4 w-2/3 rounded-full bg-[rgba(26,26,26,0.08)]" />
              <div className="h-3 w-1/3 rounded-full bg-[rgba(26,26,26,0.08)]" />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
